// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_2FpGKx7ghL","noRecordsLabelBlock":"_1uRiV7EwnW","noRecordsIcon":"_1ptHSLSpsS","noRecordsTitle":"_3PAgxijIqk"};